"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Trends_1 = require("@/pages/common/components/Trends");
var mapStateToProps = function (state, ownProps) { return ({
    buildingName: state.detail.property.building,
    trends: state.trends,
    isMobile: ownProps.isMobile,
    hidden: ownProps.hidden,
}); };
var mapDispatchToProps = function () { return ({}); };
var detailChart = function (props) {
    if (!props.trends || !props.trends.newChartGroups || !props.trends.newChartGroups.length)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "l-prop__chart l-pad-top l-pad-top--2", style: { display: props.hidden ? 'none' : 'block' } },
        React.createElement("div", { className: "o-h1 c-trends__title u-mobile-hidden" },
            props.buildingName,
            " - ",
            props.trends.t.trend),
        React.createElement("div", { className: "l-prop__chart-body l-pad l-pad--4" },
            React.createElement(Trends_1.default, { isMobile: props.isMobile }))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(detailChart);
